import { FormGroup, Input, Label } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkInput } from "../../Utils/otherFunctions";
import { forwardRef } from "react";

const InputField = forwardRef(function InputField(props, ref) {
  const { label, className, fieldState, placeholder } = props;
  const { themeContext } = useThemeContext();

  return (
    <FormGroup className={`d-flex align-items-center ${className}`}>
      {label && (
        <Label className={`bg-transparent`}>
          {label}{" "}
          {props.isRequired && (
            <font className="ml-1" color="red">
              *
            </font>
          )}
        </Label>
      )}
      <Input
        className={`btn-primary mx-4 mb-2 ${getDarkInput(
          themeContext
        )} ${className}`}
        invalid={fieldState?.error}
        type="checkbox"
        placeholder={placeholder}
        ref={ref}
        {...props}
      />
      <div className="mb-1">{placeholder}</div>
      {fieldState?.error && (
        <Label className={"label-text text-danger"}>
          {fieldState.error.message}
        </Label>
      )}
    </FormGroup>
  );
});

export default InputField;
